export const languagesCodes = ['it', 'en', 'es'];
